import { useEffect, useState } from 'react'

export enum BrowserName {
  chrome = 'Chrome',
  firefox = 'Firefox',
  safari = 'Safari',
  opera = 'Opera',
  edge = 'Edge',
  internetExplorer = 'Internet Explorer',
  unknown = 'Unknown',
}

interface BrowserInfo {
  name: BrowserName
  version: string
}

const detectBrowser = (): BrowserInfo => {
  const userAgent = navigator.userAgent

  if (/chrome|crios|crmo/i.test(userAgent) && !/edge|edg|opr|opera/i.test(userAgent)) {
    return {
      name: BrowserName.chrome,
      version: /Chrome\/([0-9.]+)/i.exec(userAgent)?.[1] || 'unknown',
    }
  }

  if (/firefox|fxios/i.test(userAgent)) {
    return {
      name: BrowserName.firefox,
      version: /Firefox\/([0-9.]+)/i.exec(userAgent)?.[1] || 'unknown',
    }
  }

  if (/safari/i.test(userAgent) && !/chrome|crios|crmo|chromium/i.test(userAgent)) {
    return {
      name: BrowserName.safari,
      version: /Version\/([0-9.]+)/i.exec(userAgent)?.[1] || 'unknown',
    }
  }

  if (/opr|opera/i.test(userAgent)) {
    return {
      name: BrowserName.opera,
      version: /Opera\/([0-9.]+)|OPR\/([0-9.]+)/i.exec(userAgent)?.[1] || 'unknown',
    }
  }

  if (/edg/i.test(userAgent)) {
    return { name: BrowserName.edge, version: /Edg\/([0-9.]+)/i.exec(userAgent)?.[1] || 'unknown' }
  }

  if (/msie|trident/i.test(userAgent)) {
    return {
      name: BrowserName.internetExplorer,
      version: /MSIE ([0-9.]+)|rv:([0-9.]+)/i.exec(userAgent)?.[1] || 'unknown',
    }
  }

  return { name: BrowserName.unknown, version: 'unknown' }
}

export const useBrowser = (): BrowserInfo => {
  const [browserInfo, setBrowserInfo] = useState<BrowserInfo>({
    name: BrowserName.unknown,
    version: 'unknown',
  })

  useEffect(() => {
    const info = detectBrowser()
    setBrowserInfo(info)
  }, [])

  return browserInfo
}
